<template>
    <el-dialog :visible.sync="visible" :title="appealType ===1 ? '申诉通过' : '驳回原因'" :close-on-click-modal="false"
               :close-on-press-escape="false" :append-to-body="true">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item prop="score" v-if="appealType===1">
                <span>重新选择其他评分，或者返还分数 !</span>
            </el-form-item>
            <el-form-item label="重新选择" v-if="appealType===1">
                <el-select v-model="dataForm.evaluateItemId" placeholder="原因" clearable>
                  <el-option v-for="evaluateItem in evaluateItemList"
                             :label="`${evaluateItem.evaluateItemName}（扣${evaluateItem.score}分） `"
                             :value="evaluateItem.id"
                             :key="evaluateItem.id">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="驳回原因" prop="auditReason" v-if="appealType===2">
                <el-input v-model="dataForm.auditReason" placeholder="请输入驳回原因"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { appeal } from '@/constant'

export default {
  data () {
    return {
      appeal,
      visible: false,
      appealId: '',
      appealType: '',
      // evaluateItemId: '',
      evaluateItemList: [],
      dataForm: {
        id: '',
        state: '',
        auditReason: '',
        evaluateItemId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {}
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.appealId) {
          this.getInfo()
        }
      })
    },
    add () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.evaluateScoreId) {
          this.getEvaluatescore()
        }
      })
    },
    // 获取分数信息
    getEvaluatescore () {
      this.$http.get('/classEvaluate/evaluateScore/info/' + this.dataForm.evaluateScoreId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.evaluateItemId = this.dataForm.evaluateItemId
        this.getEvaluateItem(this.dataForm.evaluateItemId)
        this.dataForm.evaluateItemId = ''
      }).catch(() => {
      })
    },
    // // 先根据分数id获取分数详情
    // getEvaluateItem2 () {
    //   this.$http.get('/classEvaluate/evaluateScore/' + this.dataForm.evaluateScoreId).then(({ data: res }) => {
    //     if (res.code !== 0) {
    //       return this.$message.error(res.msg)
    //     }
    //     console.log(res.data.evaluateItemId)
    //     this.evaluateItemId = res.data.evaluateItemId
    //     console.log(this.evaluateItemId)
    //   })
    // },

    // 获取评分项目
    getEvaluateItem (id) {
      this.$http.get('/classEvaluate/evaluateItem/item/' + id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.evaluateItemList = res.data
      }).catch(() => {
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/appeal/appeal/' + this.appealId).then(({ data: res }) => {
        console.log(this.appealId)
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.appealId = this.dataForm.id
        if (this.appealType === 1) {
          this.getEvaluatescore()
        }
      }).catch(() => {
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.id = this.appealId
        this.dataForm.state = this.appealType
        // this.dataForm.evaluateItemId = this.appealEvaluateItemId
        this.$http.put('/appeal/appeal/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('init')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, {
      leading: true,
      trailing: false
    })
  }
}
</script>
